import apiUrl from '../../../../utils/settings';

export const getUserFirmsUrl = () => {
  return apiUrl + '/company/firms';
};
export const SendOTPThroughExistingUserUrl = () => {
  return apiUrl + '/onboarding/send-otp-request-by-through-existing-user';
};
export const addUserThroughExistingCompanyUrl = () => {
  return apiUrl + '/onboarding/add-user-through-existing-company';
};
